import client from './client';

// ── Admin endpoints (require an authenticated admin) ─────────────────── //

// List pending invites for a tenant. Super-admins can pass any tenant id;
// regular admins are pinned server-side to their own.
export const listInvites = (params) =>
  client.get('/invites', { params }).then((r) => r.data);

// Re-send the branded SES invite. Only valid while the invite is in
// pending/sent/opened state.
export const resendInvite = (inviteId) =>
  client.post(`/invites/${inviteId}/resend`).then((r) => r.data);

// Revoke an invite — the token immediately stops working but the row
// is kept for audit. Accepted invites can't be revoked.
export const revokeInvite = (inviteId) =>
  client.delete(`/invites/${inviteId}`).then((r) => r.data);

// ── Public endpoints (token IS the auth) ─────────────────────────────── //

// Used by the /invite/{token} landing page. The server stamps
// opened_at on the first call so the admin can see "they clicked".
export const getInviteByToken = (token) =>
  client.get(`/invites/${token}`).then((r) => r.data);

// Accept the invite by committing the password the user chose on the
// landing page (set permanently in Cognito server-side). The frontend
// then redirects to /auth/login to sign in with that password.
export const acceptInvite = (token, password) =>
  client.post(`/invites/${token}/accept`, { password }).then((r) => r.data);
